import React, {ReactNode} from 'react';
import {Platform} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import RNPickerSelect from 'react-native-picker-select';
import Feather from 'react-native-vector-icons/Feather';

import {Container, InputPicker, PickerField, Label} from './styles';
import {useTheme} from 'styled-components/native';

interface PickerItems {
  label: string;
  value: string;
}

interface IPicker {
  label?: string;
  leftComponent?: ReactNode;
  placeholder: {
    label: string;
    value: string;
  };
  value?: string;
  items: PickerItems[];
  onChangeValue: (value: any, index: number) => void;
}

export function Picker({
  label,
  leftComponent,
  placeholder,
  onChangeValue,
  value,
  items,
}: IPicker) {
  const theme = useTheme();
  const PickerStyle = {
    fontSize: RFValue(12),
    color: theme.colors.text_dark,
    height: RFValue(45),
    fontFamily: theme.fonts.regular,
  };

  return (
    <Container>
      {label && <Label>{label}</Label>}
      <InputPicker>
        {leftComponent}
        <PickerField>
          <RNPickerSelect
            placeholder={placeholder}
            onValueChange={onChangeValue}
            style={{
              inputAndroid: PickerStyle,
              inputIOS: PickerStyle,

              viewContainer: {
                flex: 1,
              },
              iconContainer: {
                alignItems: 'center',
                justifyContent: 'center',
                height: RFValue(45),
              },
              placeholder: {
                color: theme.colors.placeholder,
              },
            }}
            value={value}
            items={items}
            {...((Platform.OS !== 'web'
              ? {
                  useNativeAndroidPickerStyle: false,
                  Icon: () => (
                    <Feather
                      name="chevron-down"
                      size={RFValue(12)}
                      color={theme.colors.text_dark}
                    />
                  ),
                }
              : {}) as any)}
          />
        </PickerField>
      </InputPicker>
    </Container>
  );
}